import axios from './axios';
import SETTINGS from '../settings'
export default {
    getSolutions(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/solution`, {params}).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    getSolution(id, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/solution/${id}?_embed=1`).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
}